import RemaxLogo from '../landing/remax-logo.svg';
import DouglasLogo from '../landing/douglas-logo.svg';
import SothebyLogo from '../landing/sotheby-logo.svg';
import CompassLogo from '../landing/compass-logo.svg';
import ColdWellLogo from '../landing/coldwell-logo.svg';

export const LOGOS = {
  RemaxLogo, DouglasLogo, SothebyLogo, CompassLogo, ColdWellLogo
}